(function(){
    'use strict'

    angular
    .module('app.companias')
    .controller('SeleccionarCompania', SeleccionarCompania);

    SeleccionarCompania.$inject = ['$animationsSrv', 'CompaniasService', 'logger', '$location', 'UserInfoService'];

    function SeleccionarCompania($animationsSrv, CompaniasService, logger, $location, UserInfoService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.companias = [];
        vm.title = 'Companias';

        vm.selectCompania = function(compania){
            
            UserInfoService.setCompania(compania);

            var path = '/principal';

            $location.path(path);

            logger.info('compañia seleccionada. ' + compania.nombre);
        };

        getAll();

        function getAll(){

            var promise = CompaniasService.getAll();

            promise
            .then(function(companias){
                vm.companias = companias;
                logger.info('Selecciona la compañia.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        UserInfoService.setToken(null);
                        break;
                
                    default:
                        logger.error('Error al obtener las companias.');
                        break;
                }
            });
        };

    }
})();